import React from 'react';
import { useNavigate } from 'react-router-dom';
import './error.css'; // You can add custom styles here

export default function ErrorComponent() {
    const navigate = useNavigate();

    return (
        <div className="ErrorComponent d-flex align-items-center justify-content-center vh-100">
            <div className="text-center">
                <h1 className="display-1">404</h1>
                <h2>Oops! Page Not Found</h2>
                <p className="lead">
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <button 
                    className="btn btn-lg btn-primary mt-4 px-5 py-2" 
                    onClick={() => navigate('/')}
                >
                    Go Back to Login
                </button>
            </div>
        </div>
    );
}
